import {SupportProduct} from "../model/support/SupportProduct";
import {OrderProduct} from "@/model/OrderProduct";
import {Service} from "vue-typedi";

@Service()
export class ConvertProductService {

    public convertOrderProductToSupportProduct(orderProduct: OrderProduct): SupportProduct {
        const supportProduct = new SupportProduct();
        supportProduct.cug = orderProduct.cug;
        supportProduct.label = orderProduct.label;
        supportProduct.origin = orderProduct.origin;
        supportProduct.thumbnail = orderProduct.thumbnail;
        supportProduct.processedQuantity = orderProduct.processedQuantity.value;
        supportProduct.orderLineNumber = orderProduct.orderLineNumber;
        return supportProduct;
    }
}